'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _container_plugin = require('../../base/container_plugin');

var _container_plugin2 = _interopRequireDefault(_container_plugin);

var _events = require('../../base/events');

var _events2 = _interopRequireDefault(_events);

var _playback = require('../../base/playback');

var _playback2 = _interopRequireDefault(_playback);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClickToPausePlugin = function (_ContainerPlugin) {
  (0, _inherits3.default)(ClickToPausePlugin, _ContainerPlugin);
  (0, _createClass3.default)(ClickToPausePlugin, [{
    key: 'name',
    get: function get() {
      return 'click_to_pause';
    }
  }]);

  function ClickToPausePlugin(container) {
    (0, _classCallCheck3.default)(this, ClickToPausePlugin);
    return (0, _possibleConstructorReturn3.default)(this, (ClickToPausePlugin.__proto__ || (0, _getPrototypeOf2.default)(ClickToPausePlugin)).call(this, container));
  }

  (0, _createClass3.default)(ClickToPausePlugin, [{
    key: 'bindEvents',
    value: function bindEvents() {
      this.listenTo(this.container, _events2.default.CONTAINER_CLICK, this.click);
      this.listenTo(this.container, _events2.default.CONTAINER_SETTINGSUPDATE, this.settingsUpdate);
    }
  }, {
    key: 'click',
    value: function click() {
      if (this.container.getPlaybackType() !== _playback2.default.LIVE || this.container.isDvrEnabled()) {
        if (this.container.isPlaying()) this.container.pause();else this.container.play();
      }
    }
  }, {
    key: 'settingsUpdate',
    value: function settingsUpdate() {
      var pointerEnabled = this.container.getPlaybackType() !== _playback2.default.LIVE || this.container.isDvrEnabled();
      if (pointerEnabled === this.pointerEnabled) return;

      var method = pointerEnabled ? 'addClass' : 'removeClass';
      this.container.$el[method]('pointer-enabled');
      this.pointerEnabled = pointerEnabled;
    }
  }]);
  return ClickToPausePlugin;
}(_container_plugin2.default); //Copyright 2014 Globo.com Player authors. All rights reserved.
// Use of this source code is governed by a BSD-style
// license that can be found in the LICENSE file.

exports.default = ClickToPausePlugin;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/clappr/src/plugins/click_to_pause/click_to_pause.js
// module id = 283
// module chunks = 0